'use client'

import type { AutoFormWidgetsProps } from '../autoForm'
import { InputWidget } from './inputWidget'
import { useRef } from 'react'

export function DateWidget({ initialValue, ...props }: AutoFormWidgetsProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  let parsedValue = initialValue
  if (initialValue instanceof Date) {
    // Converter para timezone de São Paulo e formato ISO para datetime-local
    const date = new Date(initialValue)
    const spDate = new Date(date.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }))
    parsedValue = spDate.toISOString().slice(0, 16)
  }

  return (
    <InputWidget
      type="datetime-local"
      {...props}
      initialValue={parsedValue}
      inputRef={inputRef}
      inputProps={{
        'data-vaul-no-drag': true,
        onPointerDownCapture: (e) => {
          // Evita o Vaul interpretar a interação como drag do drawer
          e.stopPropagation()
          // Alguns componentes (ex: Vaul/Drawer) podem chamar preventDefault no gesture
          // e impedir o click/focus nativo do input. Forçamos o foco + picker aqui.
          try {
            inputRef.current?.focus()
          } catch {}
          try {
            ;(inputRef.current as any)?.showPicker?.()
          } catch {}
        },
        // Mantém os handlers abaixo como fallback (ex: navegação por teclado)
        onClick: () => {
          try {
            ;(inputRef.current as any)?.showPicker?.()
          } catch {}
        },
        onFocus: () => {
          try {
            ;(inputRef.current as any)?.showPicker?.()
          } catch {}
        },
      }}
    />
  )
}
